var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('multiselect',{attrs:{"placeholder":"Select Vendor","options":_vm.vendors.data,"label":"name","track-by":"id","value":_vm.selected},on:{"input":_vm.handleInput,"remove":_vm.handleRemove}})}
var staticRenderFns = []

export { render, staticRenderFns }